import React from "react";
import { IoSyncCircle } from "react-icons/io5";
import "./VerificationStatus.css";

const VerificationStatus = ({ status, confidence }) => {
  const getStatusText = () => {
    switch (status) {
      case "MATCH":
        return "Face Verified";
      case "NO_MATCH":
        return "Face Not Verified";
      default:
        return "Verifying...";
    }
  };

  const getStatusImage = () => {
    switch (status) {
      case "MATCH":
        return (
          <img
            src="/matched.png"
            alt="Verified"
            className="verification-icon verified"
          />
        );
      case "NO_MATCH":
        return (
          <img
            src="/not-matched.png"
            alt="Not Verified"
            className="verification-icon unverified"
          />
        );
      default:
        return <IoSyncCircle className="verification-icon pending spinning" />;
    }
  };

  return (
    <div className="verification-status" title={getStatusText()}>
      {getStatusImage()}
    </div>
  );
};

export default VerificationStatus;
